import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../../core/layout/Dialog';
import Separator from '../../../core/layout/Separator';
import Divider from '../../../core/layout/Divider';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import TextInput from '../../../core/form/TextInput';
import { get } from 'lodash';
import FormButtons from '../../../core/form/FormButtons';

const CreateCertificationItemDraftDialog = (props) => (
  <Dialog title="Create Draft" isOpen={props.isOpen} onCancel={props.onCancel} actions={null} width={1000}>
    <div>
      <b>Course</b>: <span>{props.certificationTestCourseAbilityItem.certificationTestCourseAbility.course.name}</span>
    </div>
    <Separator size="sm" />
    <div>
      <b>Ability</b>: <span>{props.certificationTestCourseAbilityItem.certificationTestCourseAbility.ability}</span>
    </div>
    <Separator size="sm" />
    <div>
      <b>Grammar</b>: <span>{props.certificationTestCourseAbilityItem.item.grammar.name}</span>
    </div>
    <Separator size="sm" />
    <div>
      <b>Text</b>: <span>{props.certificationTestCourseAbilityItem.item.text}</span>
    </div>
    <Separator size="sm" />
    <Divider title="" />
    <form
      onSubmit={(event) => {
        event.preventDefault();
        props.onSubmit();
      }}
    >
      <Row>
        <Column size={12}>
          <TextInput
            required
            label="What is the change reason?"
            fieldType="textarea"
            disabled={props.submitting}
            value={get(props.values, 'draftCreationReason', '')}
            onChange={(value) => props.onChange('draftCreationReason', value)}
            errorText={get(props.errors, 'draftCreationReason', '')}
            textAreaRows="4"
          />
        </Column>
      </Row>
      <Separator size="xs" />
      <FormButtons
        confirmLabel="Create"
        isDisabled={props.submitting}
        isSubmitting={props.submitting}
        onReset={props.onCancel}
      />
    </form>
  </Dialog>
);

CreateCertificationItemDraftDialog.propTypes = {
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  values: PropTypes.object,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  certificationTestCourseAbilityItem: PropTypes.shape({
    certificationTestCourseAbility: PropTypes.shape({
      id: PropTypes.string.isRequired,
      ability: PropTypes.string.isRequired,
      course: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }),
    }),
    item: PropTypes.shape({
      text: PropTypes.string.isRequired,
      grammar: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }),
    }),
  }).isRequired,
};

CreateCertificationItemDraftDialog.defaultProps = {
  values: {},
  errors: {},
  isOpen: false,
  submitting: false,
};

export default CreateCertificationItemDraftDialog;
